<template>
  <div id="main">
    <div class="container">
      <div class="form">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
          <el-form-item label="公司名称" prop="e_name">
            <el-input v-model="ruleForm.e_name" placeholder="请填写公司名称"></el-input>
          </el-form-item>
          <el-form-item label="行业类型" prop="trade">
            <el-select v-model="ruleForm.trade" placeholder="请选择行业类型">
              <el-option v-for="item in tradeList" :key="item.id" :label="item.value" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所在区域" required>
            <div class="area">
              <el-form-item prop="xixun_province_id">
                <el-select v-model="ruleForm.xixun_province_id" placeholder="请选择省份" @change="changeProvince" ref='province'>
                  <el-option v-for="item in $store.state.provinces" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item prop="xixun_city_id">
                <el-select v-model="ruleForm.xixun_city_id" placeholder="请选择市" @change="changeCity" ref='city'>
                  <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="xixun_county_id">
                <el-select v-model="ruleForm.xixun_county_id" placeholder="请选择区县" ref='country'>
                  <el-option v-for="item in countyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item label="详细地址" prop="address">
            <el-input v-model="ruleForm.address" placeholder="请填写详细地址"></el-input>
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="uscc">
            <el-input v-model="ruleForm.uscc" placeholder="请填写统一社会信用代码"></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="contact_name">
            <el-input v-model="ruleForm.contact_name" placeholder="请填写联系人"></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="contact_mob">
            <el-input v-model="ruleForm.contact_mob" placeholder="请填写手机号码"></el-input>
          </el-form-item>
          <el-form-item label="职位">
            <el-input v-model="ruleForm.contact_job" placeholder="请填写职位"></el-input>
          </el-form-item>
          <el-form-item label="公司介绍" prop="brief">
            <el-input :autosize="{ minRows: 5, maxRows: 8 }" type="textarea" v-model="ruleForm.brief" placeholder="请输入介绍信息"></el-input>
          </el-form-item>
          <el-form-item>
            <!-- <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button> -->
            <button class="next" @click.prevent="submitForm('ruleForm')">下一步</button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { validPhone, validUscc } from "@/assets/js/validate";
import formatter from "@/assets/js/mixins/formatter";
import vconsole from "vconsole";

export default {
  mixins: [formatter],
  data() {
    return {
      // 表单
      ruleForm: {
        id: "",
        e_name: "",
        trade: "",
        xixun_province_id: "",
        xixun_city_id: "",
        xixun_county_id: "",
        address: "",
        uscc: "",
        contact_name: "",
        contact_mob: "",
        contact_job: "",
        brief: "",
        contact_school: this.$route.params.school_id,
        invite_code: this.$route.params.id,
        register_source: this.$route.query.register_source,
        student_id: this.$route.query.student_id
      },
      // 行业类型、省、市、县列表
      tradeList: "",
      provinceList: "",
      cityList: "",
      countyList: "",
      // 验证规则
      rules: {
        e_name: [
          { required: true, message: "请输入公司名称", trigger: "blur" }
        ],
        contact_name: [
          { required: true, message: "请输入联系人", trigger: "blur" }
        ],
        contact_mob: [
          { required: true, message: "请输入联系人电话", trigger: "blur" }
        ],
        brief: [
          { required: true, message: "请输入公司介绍", trigger: "blur" }
        ],
        trade: [
          { required: true, message: "请选择行业类型", trigger: "change" }
        ],
        xixun_province_id: [
          {
            required: true,
            message: "请选择省份",
            trigger: ["blur", "change"]
          }
        ],
        xixun_city_id: [
          {
            required: true,
            message: "请选择城市",
            trigger: ["blur", "change"]
          }
        ],
        xixun_county_id: [
          {
            required: true,
            message: "请选择区县",
            trigger: ["blur", "change"]
          }
        ],
        uscc: [{ required: true, trigger: "blur", validator: validUscc }],
        // contact_name: [
        //   { required: true, message: "请填写联系人", trigger: "blur" }
        // ],
        // contact_mob: [
        //   { required: true, trigger: "blur", validator: validPhone }
        // ],
        address: [
          { required: true, message: "请填写公司地址", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    this.getTrade();
    this.getInfo();
  },
  methods: {
    // 获取企业基本信息
    async getInfo() {
      let res = await this.$api.info.get();
      if (res.code === 0) {
        if (res.data.length === 0) {
          return;
        }
        let item = res.data[0];
        // this.ruleForm.id = item.id;
        this.ruleForm.e_name = item.e_name;
        this.ruleForm.trade = Number(item.trade);
        this.ruleForm.xixun_province_id = item.xixun_province_id;
        item.xixun_province_id
          ? this.changeProvince(item.xixun_province_id)
          : "";
        this.ruleForm.xixun_city_id = item.xixun_city_id;
        item.xixun_city_id ? this.changeCity(item.xixun_city_id) : "";
        this.ruleForm.xixun_county_id = item.xixun_county_id;
        this.ruleForm.address = item.address;
        this.ruleForm.uscc = item.uscc;
        this.ruleForm.contact_name = item.contact_name;
        this.ruleForm.contact_mob = item.contact_mob;
        this.ruleForm.contact_job = item.contact_job;
        this.ruleForm.brief = item.brief;
      }
      // if (res.code === 401) {
      //   if (this.$route.query.invite_student_id) {
      //     this.$router.push(
      //       `/share/${school_id}/${id}?register_source=${this.$route.query.register_source}&student_id=${this.$route.query.invite_student_id}`
      //     );
      //   } else {
      //     this.$router.push(
      //       `/share/${school_id}/${id}?register_source=${this.$route.query.register_source}`
      //     );
      //   }
      // }
    },
    // 行业类型
    async getTrade() {
      let res = await this.$api.common.getTrade();
      this.tradeList = res.data;
    },
    // 选择省
    async changeProvince(val) {
      this.ruleForm.xixun_city_id = null;
      this.ruleForm.xixun_county_id = null;
      let res = await this.$api.common.getXixunCity(val);
      if (res.code === 0) {
        this.cityList = res.data;
      }
    },
    // 选择市
    async changeCity(val) {
      this.ruleForm.xixun_county_id = null;
      let res = await this.$api.common.getXixunCounty(val);
      if (res.code === 0) {
        this.countyList = res.data;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.addInfo();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async addInfo() {
      let params = this.delNullVal(this.ruleForm);
      let res = await this.$api.info.add(params);
      if (res.code === 0) {
        localStorage.setItem("id", res.data.id);
        let school_id = this.$route.params.school_id;
        let id = this.$route.params.id;

        if (this.$route.query.register_source === "school") {
          this.$router.push({
            path: `/upload/${school_id}/${id}`,
            query: {
              register_source: this.$route.query.register_source
            }
          });
        } else {
          let register_source = this.$route.query.register_source;
          let student_id = this.$route.query.student_id;

          this.$router.push({
            path: `/upload/${school_id}/${id}`,
            query: {
              register_source,
              student_id
            }
          });
        }
      } else {
        this.$message({
          message: res.msg,
          center: true
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/base.scss";

#main {
  margin: 0;
  font-size: 14px;
  height: 100%;
  color: #505050;
  background: url("../../assets/img/bg.png") no-repeat;
  background-size: 100%;
  padding: 20px 16px 50px;

  .container {
    background: #fff;
    border-radius: vw(23);

    .form {
      padding: 20px 10px 30px;

      .area {
        @include flex;
      }

      .el-select {
        width: 100%;
      }

      img {
        widows: 30px;
        height: 30px;
      }

      .next {
        width: 100%;
        height: vw(67);
        text-align: center;
        line-height: vw(67);
        border-radius: vw(33);
        background: #66aef4;
        color: #fff;
        font-size: vw(28);
        border: none;
        outline: none;
      }
    }
  }
}

@media screen and (min-width: 500px) {
  #main {
    background-size: 100% 500px;
    .container {
      width: 400px;
      margin: 0 auto;
      .form {
        .next {
          height: 50px;
          line-height: 50px;
          font-size: 18px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.el-form-item {
  margin-bottom: 15px;

  .el-form-item__content {
    clear: both;
    margin-left: 0px !important;

    .el-input__inner {
      padding: 0 7px;
    }
  }
}
</style>
